import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex items-center cursor-pointer" }
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = { class: "ml-2" }

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TwRadioButton',
  props: {
  options: {
    type: Array as () => Array<{ label: string; value: string }>,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;
const localValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue;
  }
);

const updateValue = () => {
  emits("update:modelValue", localValue.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option.value,
        class: "flex items-center mb-2"
      }, [
        _createElementVNode("label", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: __props.name,
            value: option.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
            class: "form-radio",
            onChange: updateValue
          }, null, 40, _hoisted_2), [
            [_vModelRadio, localValue.value]
          ]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(option.label), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})